import type { LscCsvImportDetails, LscCsvImportIssue } from './types';

export function formatImportIssues(issues: LscCsvImportIssue[] | string[] | undefined): string[] {
  if (!issues?.length) return [];
  return issues.map((issue) => {
    if (typeof issue === 'string') return issue;
    const parts = [issue.message];
    if (issue.row_number != null) parts.push(`(row ${issue.row_number})`);
    if (issue.field) parts.push(`[${issue.field}]`);
    if (issue.details?.conflicting_row_numbers) {
      parts.push(`rows ${String(issue.details.conflicting_row_numbers)}`);
    }
    if (issue.details?.id_source_field) {
      parts.push(`source=${String(issue.details.id_source_field)}`);
    }
    return parts.join(' ');
  });
}

export function formatCsvImportErrorMessage(
  message: string,
  details?: LscCsvImportDetails
): string {
  const lines = [message];
  if (!details) return lines.join('\n');

  if (details.detected_format) {
    lines.push(`Detected format: ${details.detected_format}`);
  }
  if (details.missing_columns?.length) {
    lines.push(`Missing columns: ${details.missing_columns.join(', ')}`);
  }
  if (details.detected_columns?.length) {
    lines.push(`Detected columns: ${details.detected_columns.join(', ')}`);
  }
  if (details.supported_formats?.length) {
    lines.push(`Supported formats: ${details.supported_formats.join(', ')}`);
  }
  return lines.join('\n');
}

export interface ParsedParticipantPreview {
  sideLabel: string;
  sourceIdentity: string;
  inGameIdentity: string;
  twitchLogin: string;
}

export function extractParticipantPreview(
  snapshotPreview?: Record<string, unknown>
): ParsedParticipantPreview[] {
  const participants = snapshotPreview?.participants;
  if (!Array.isArray(participants)) return [];

  return participants.map((raw) => {
    const participant = raw as Record<string, unknown>;
    const sourceMetadata = (participant.source_metadata as Record<string, unknown>) || {};
    const neonsportz = (sourceMetadata.neonsportz as Record<string, unknown>) || {};
    const gameIdentity = (sourceMetadata.game_identity as Record<string, unknown>) || {};
    return {
      sideLabel: String(participant.side_label || neonsportz.displayName || '—'),
      sourceIdentity: String(participant.identity_value || neonsportz.userName || '—'),
      inGameIdentity: String(neonsportz.in_game_name || gameIdentity.value || '—'),
      twitchLogin: String(participant.stream_login || 'Missing'),
    };
  });
}
